<template>
    <div>
        <multiselect v-model="value" deselect-label="Entfernen" track-by="name" label="name"
                     placeholder="Auswählen" :options="tags" :searchable="true" :allow-empty="true" :multiple="true"
                     :hide-selected="true" :taggable="true" @close="writeValue" @tag="addTag">
        </multiselect>
        <input type="hidden" :name="fieldName" v-model="parsedValue" :id="fieldName">
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect';

    export default {
        props: ["tags", "fieldName", "origValue"],
        components: {
            Multiselect
        },
        mounted() {
        },
	    methods: {
            writeValue(value) {
                this.parsedValue = JSON.stringify(this.value);
            },
            addTag(tag) {
                const newTag = {"name":tag};
                this.tags.push(newTag);
                this.value.push(newTag);
//                this.writeValue(newTag); ~ shall be written onclose
            }
        },
        data() {
            return {
                value: this.origValue,
                parsedValue: JSON.stringify(this.origValue)
            }
        }
    }
</script>
